import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Sun, Flame, Home, CheckCircle2 } from 'lucide-react';

const Solutions = () => {
  return (
    <div style={{ background: 'var(--bg-page)', minHeight: '100vh' }}>
      <section style={{ paddingTop: '140px', paddingBottom: '64px', background: 'var(--bg-card)' }}>
        <div className="container">
          <h1 className="display-medium" style={{ textAlign: 'center', color: 'var(--text-primary)', marginBottom: '24px' }}>
            Nos Solutions Énergétiques
          </h1>
          <p className="body-large" style={{ textAlign: 'center', color: 'var(--text-secondary)', maxWidth: '800px', margin: '0 auto' }}>
            Découvrez nos solutions complètes pour réduire votre consommation d énergie et participer activement à la transition énergétique.
          </p>
        </div>
      </section>

      <section className="pad-giant">
        <div className="container">
          {/* Solaire */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '48px', alignItems: 'center', marginBottom: '64px' }}>
            <div>
              <div style={{ borderRadius: '32px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0, 69, 52, 0.15)', height: '400px' }}>
                <img src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d" alt="Solaire" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            </div>
            <div>
              <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                <Sun size={28} style={{ color: 'var(--brand-dark)' }} />
              </div>
              <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '16px' }}>Énergie Solaire</h2>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
                Produisez votre propre électricité et réduisez vos factures jusqu à 40%. Panneaux photovoltaïques dernière génération avec garantie 25 ans.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px 0' }}>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Jusqu à 40% d économies sur votre facture électrique</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Installation certifiée RGE avec garantie 25 ans</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Revente du surplus à EDF OA</span>
                </li>
              </ul>
              <Link to="/solutions/solaire" className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                En savoir plus <ArrowRight size={20} />
              </Link>
            </div>
          </div>

          {/* Chauffage */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '48px', alignItems: 'center', marginBottom: '64px' }}>
            <div style={{ order: 2 }}>
              <div style={{ borderRadius: '32px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0, 69, 52, 0.15)', height: '400px' }}>
                <img src="https://images.unsplash.com/photo-1509391366360-2e959784a276" alt="Chauffage" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            </div>
            <div style={{ order: 1 }}>
              <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                <Flame size={28} style={{ color: 'var(--brand-dark)' }} />
              </div>
              <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '16px' }}>Chauffage Écologique</h2>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
                Pompe à chaleur air-eau ou air-air pour chauffer efficacement et moins cher. Jusqu à 60% d économies sur votre facture de chauffage.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px 0' }}>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Jusqu à 60% d économies de chauffage</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Chauffage l hiver + climatisation l été</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Éligible aux aides de l État</span>
                </li>
              </ul>
              <Link to="/devis" className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                Demander un devis <ArrowRight size={20} />
              </Link>
            </div>
          </div>

          {/* Isolation */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '48px', alignItems: 'center' }}>
            <div>
              <div style={{ borderRadius: '32px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0, 69, 52, 0.15)', height: '400px' }}>
                <img src="https://images.unsplash.com/photo-1621157281974-e926449624e3" alt="Isolation" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            </div>
            <div>
              <div style={{ width: '56px', height: '56px', borderRadius: '50%', background: 'var(--brand-primary)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '24px' }}>
                <Home size={28} style={{ color: 'var(--brand-dark)' }} />
              </div>
              <h2 className="heading-2" style={{ color: 'var(--text-primary)', marginBottom: '16px' }}>Isolation Thermique</h2>
              <p className="body-large" style={{ color: 'var(--text-secondary)', marginBottom: '32px' }}>
                Isolation des murs par l extérieur ou des combles perdus. Jusqu à +3°C l hiver et -3°C l été pour un confort optimal toute l année.
              </p>
              <ul style={{ listStyle: 'none', padding: 0, margin: '0 0 32px 0' }}>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Jusqu à 30% d économies sur le chauffage</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>+3°C en hiver, -3°C en été</span>
                </li>
                <li style={{ display: 'flex', alignItems: 'start', gap: '12px', marginBottom: '16px', fontSize: 'clamp(1rem, 2vw, 1.125rem)', color: 'var(--text-secondary)' }}>
                  <CheckCircle2 size={20} style={{ color: 'var(--brand-primary)', flexShrink: 0, marginTop: '2px' }} />
                  <span>Valorisation de votre bien immobilier</span>
                </li>
              </ul>
              <Link to="/devis" className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
                Demander un devis <ArrowRight size={20} />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Solutions;
